(function () {
    'use strict';

    angular
        .module('tikonApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('account-clearing-request', {
                parent: 'entity',
                url: '/account-clearing-request?page&sort&search',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-requests.html',
                        controller: 'AccountClearingRequestController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('account-clearing-request-detail', {
                parent: 'entity',
                url: '/account-clearing-request/{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'tikonApp.accountClearingRequest.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-detail.html',
                        controller: 'AccountClearingRequestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('accountClearingRequest');
                        $translatePartialLoader.addPart('accountClearingRequestStatus');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'AccountClearingRequest', function ($stateParams, AccountClearingRequest) {
                        return AccountClearingRequest.get({id: $stateParams.id}).$promise;
                    }]
                }
            })
            .state('account-clearing-request.new', {
                parent: 'account-clearing-request',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-dialog.html',
                        controller: 'AccountClearingRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    createDate: null,
                                    fromDate: null,
                                    toDate: null,
                                    totalPaymentAmount: null,
                                    totalWageFeeAmount: null,
                                    status: null,
                                    description: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('account-clearing-request', null, {reload: true});
                    }, function () {
                        $state.go('account-clearing-request');
                    });
                }]
            })
            .state('account-clearing-request.edit', {
                parent: 'account-clearing-request',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-dialog.html',
                        controller: 'AccountClearingRequestDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['AccountClearingRequest', function (AccountClearingRequest) {
                                return AccountClearingRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('account-clearing-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('account-clearing-request.delete', {
                parent: 'account-clearing-request',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/account-clearing-request/account-clearing-request-delete-dialog.html',
                        controller: 'AccountClearingRequestDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['AccountClearingRequest', function (AccountClearingRequest) {
                                return AccountClearingRequest.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('account-clearing-request', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
